function readErrorMessage(err: unknown): string {
  if (err instanceof Error) return err.message;
  if (typeof err === 'string') return err;
  return String(err);
}

function readErrorCode(err: unknown): string | undefined {
  if (err && typeof err === 'object' && 'code' in err) {
    const code = (err as { code: unknown }).code;
    if (typeof code === 'string') return code;
  }
  return undefined;
}

/** 是否为「需要配置 Git 凭据」类错误（含 PREPARE_FAILED 包装的凭据文案） */
export function isGitCredentialNotConfiguredError(err: unknown): boolean {
  const message = readErrorMessage(err);
  const code = readErrorCode(err);

  if (code === 'CREDENTIAL_NOT_CONFIGURED') return true;
  if (message.includes('未配置 Git 凭据')) return true;
  if (message.includes('需要配置 Git 凭据')) return true;
  if (code === 'PREPARE_FAILED' && message.includes('凭据')) return true;

  if (err && typeof err === 'object' && 'name' in err) {
    const name = (err as { name: unknown }).name;
    if (name === 'GitCredentialRequiredError') return true;
  }

  return false;
}

/** Git 树/文件路径不存在（缺 workflow/ 目录时当空列表，不当成凭据错误） */
export function isGitPathNotFoundError(err: unknown): boolean {
  if (err && typeof err === 'object' && 'status' in err) {
    if ((err as { status?: number }).status === 404) return true;
  }
  const code = readErrorCode(err);
  if (code === 'FILE_NOT_FOUND' || code === 'NOT_FOUND' || code === 'PATH_NOT_FOUND') {
    return true;
  }
  const message = readErrorMessage(err).toLowerCase();
  return message.includes('404') || message.includes('not found');
}

/** @deprecated 凭据缺失请使用 ListSchemaProfilesResult，不再抛此错误 */
export class GitCredentialRequiredError extends Error {
  constructor(message = '需要配置 Git 凭据') {
    super(message);
    this.name = 'GitCredentialRequiredError';
  }
}

export function toGitCredentialRequiredError(err: unknown): GitCredentialRequiredError | null {
  return isGitCredentialNotConfiguredError(err) ? new GitCredentialRequiredError(readErrorMessage(err)) : null;
}
